import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonsModule } from '@shared/core/components/buttons';
import { HeadersModule } from '@shared/core/components/headers';
import { TwoColumnsModule } from '@shared/core/components/twoColumns';
import { LinkModule } from '@shared/core/components/link';

import { ModalsTypesModule } from '../../modalsTypes';

import { ModalForDeliveryNotAvailableComponent } from './modal-for-delivery-not-available.shared.component';

@NgModule({
    declarations: [
        ModalForDeliveryNotAvailableComponent,
    ],
    imports: [
        CommonModule,
        ModalsTypesModule,
        ButtonsModule,
        HeadersModule,
        TwoColumnsModule,
        LinkModule
    ],
    exports: [
        ModalForDeliveryNotAvailableComponent,
    ],
})
export class ModalForDeliveryNotAvailableModule { }
